import { LotameClient } from "../../../lotame/LotameClient";
import { addPostalCodeDeclaredBehavior } from "../addPostalCodeDeclaredBehavior";

export function sendSubscriptionCompleted(planName: string, discountName: string, lotameClient: LotameClient): void {
  const payload = [`Ac=Subscribe|Forf=${planName}|Dis=${discountName}|`];
  addPostalCodeDeclaredBehavior(payload);
  lotameClient.callLotameApiCollect({
    behaviors: {
      act: payload,
    },
  });
}
